/**
 * @generated SignedSource<<c1357d2209eb1f18aad14bc8528cef7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type areaBackgroundRuleEditor_AreaBackgroundRuleDetailQuery$variables = {
  id: string;
};
export type areaBackgroundRuleEditor_AreaBackgroundRuleDetailQuery$data = {
  readonly areaBackgroundRule: {
    readonly areaBackgroundRuleID: number;
    readonly colorList: ReadonlyArray<string> | null;
    readonly enableImageCustomerGallery: boolean;
    readonly enableImageSellerGallery: boolean;
    readonly enableNoColor: boolean;
    readonly id: string;
    readonly imageGalleryCustomerFormat: number | null;
    readonly name: string;
    readonly printTypeIDs: ReadonlyArray<number> | null;
    readonly productsSides: ReadonlyArray<{
      readonly id: string;
      readonly productID: number;
      readonly sideID: number | null;
    }> | null;
  };
};
export type areaBackgroundRuleEditor_AreaBackgroundRuleDetailQuery = {
  response: areaBackgroundRuleEditor_AreaBackgroundRuleDetailQuery$data;
  variables: areaBackgroundRuleEditor_AreaBackgroundRuleDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AreaBackgroundRuleTool",
    "kind": "LinkedField",
    "name": "areaBackgroundRule",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "areaBackgroundRuleID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "colorList",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enableNoColor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enableImageCustomerGallery",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enableImageSellerGallery",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageGalleryCustomerFormat",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductSidesAreaBackgroundRule",
        "kind": "LinkedField",
        "name": "productsSides",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "productID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sideID",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "printTypeIDs",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "areaBackgroundRuleEditor_AreaBackgroundRuleDetailQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "areaBackgroundRuleEditor_AreaBackgroundRuleDetailQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ce520056b7b0f3d4c13f17716bbb7d5a",
    "id": null,
    "metadata": {},
    "name": "areaBackgroundRuleEditor_AreaBackgroundRuleDetailQuery",
    "operationKind": "query",
    "text": "query areaBackgroundRuleEditor_AreaBackgroundRuleDetailQuery(\n  $id: ID!\n) {\n  areaBackgroundRule(id: $id) {\n    id\n    areaBackgroundRuleID\n    name\n    colorList\n    enableNoColor\n    enableImageCustomerGallery\n    enableImageSellerGallery\n    imageGalleryCustomerFormat\n    productsSides {\n      id\n      productID\n      sideID\n    }\n    printTypeIDs\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b8088ae344ca4f7048ca09d7d9f6417";

export default node;
